import { TimeOut } from 'header/constants/timeOuts'
import { useMenus } from 'header/hooks/useMenus'
import { useHeaderActions } from 'hooks/useHeaderActions/useHeaderActions'
import { useEffect, useState } from 'react'

export function useMenuOpenState(open: boolean) {
	const [openFixed, setOpenFixed] = useState(false)
	const { hasMenuToBeOpen } = useHeaderActions()
	const { updateOpen } = useMenus()

	useEffect(() => {
		if (!open) {
			setOpenFixed(false)
			return
		}
		setTimeout(() => setOpenFixed(true), TimeOut.HOVER_OUTSIDE)
	}, [open])

	useEffect(() => {
		if (!hasMenuToBeOpen) {
			updateOpen(false)
		}
	}, [hasMenuToBeOpen])

	return { openFixed }
}
